import INTEGRATION_MENTIONS from '../integrations/IntegrationMentions';

export const filterBySearchResultType = <
  T extends Parameters<typeof getSearchResultType>[0],
>(
  type?: string,
  data?: T[],
) => (type ? data?.filter((r) => getSearchResultType(r) === type) : data) || [];

const getSearchResultType = (result: {
  comment?: unknown;
  post?: unknown;
  topic?: unknown;
  type?: string;
  user?: unknown;
  group?: unknown;
  template?: unknown;
}) => {
  // Inflect subtype from type (e.g. `task` from `asana_task`)
  if ('type' in result && result.type) {
    return (
      // @ts-expect-error
      (INTEGRATION_MENTIONS[result.type]?.searchResultType as
        | string
        | undefined) ||
      result.type.toLowerCase().split('_')[1] ||
      result.type
    );
  }

  return (
    (['post', 'topic', 'user', 'comment', 'group', 'template'] as const).find(
      (type) => type in result,
    ) || null
  );
};

export default getSearchResultType;
